import { render, staticRenderFns } from "./contract-modal.component.vue?vue&type=template&id=52d9188f&scoped=true&"
import script from "./contract-modal.component.vue?vue&type=script&lang=ts&"
export * from "./contract-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./contract-modal.component.vue?vue&type=style&index=0&id=52d9188f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d9188f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDataTable,VExpandTransition,VIcon,VSpacer})
